import type { FormState } from './_state.type';

/** Form State. */
export const formState: FormState = {
  form: {},
};
